import { render, staticRenderFns } from "./DropdownCustomContent.vue?vue&type=template&id=5204d1b8&"
import script from "./DropdownCustomContent.vue?vue&type=script&lang=js&"
export * from "./DropdownCustomContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports